// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"c4f025256b5eb847a5f6","678":"d50c0372fbd7ecb14cd5","883":"486fb13832286ce7e45e"}[chunkId] + ".js";
};